import { lazy } from 'react';

const schemaRoutes =
  process.env.REACT_APP_ENABLE_SCHEMA_EDITOR === 'true'
    ? [
        {
          path: '/schema',
          component: lazy(async () => await import('../pages/schema')),
        },
        {
          path: '/schema/create',
          component: lazy(async () => await import('../pages/schema/createSchema')),
        },
        {
          path: '/schema/edit',
          component: lazy(async () => await import('../pages/schema/editSchema')),
        },
      ]
    : [];

export const RouteList = [
  {
    path: '/all-in-one-import',
    component: lazy(async () => await import('../pages/all-in-one-import')),
    exact: true,
  },
  {
    path: '/overview',
    component: lazy(async () => await import('../pages/overview')),
    exact: true,
  },
  {
    path: '/settings',
    component: lazy(async () => await import('../pages/settings')),
    exact: true,
  },
  {
    path: '/settings/organization-settings/:slug',
    component: lazy(async () => await import('../pages/settings')),
  },
  {
    path: '/settings/organization-settings/:slug/:id',
    component: lazy(async () => await import('../pages/settings')),
  },
  {
    path: '/settings/organization-settings/vesting-templates/preview',
    component: lazy(async () => await import('../pages/settings/vesting-templates/preview')),
  },
  {
    path: '/settings/brokerage-sso-configuration/key-management/:id',
    component: lazy(
      async () => await import('../pages/settings/brokerage-sso-configuration/keyManagementModal')
    ),
  },
  {
    path: '/settings/organization-settings/grant-acceptance-template/preview',
    component: lazy(
      async () =>
        await import('../pages/settings/grant-acceptance-template/grantAcceptanceTemplatePreview')
    ),
  },
  // {
  //   path: '/settings/organization-settings/election-window-config',
  //   component: lazy(
  //     async () => await import('../pages/settings/configuration/components/election-window-config')
  //   ),
  // },
  {
    path: '/participants',
    component: lazy(async () => await import('../pages/participants/index')),
    exact: true,
  },
  // {
  //   path: '/participants/audit-log',
  //   component: lazy(async () => await import('../pages/participants/audit-logs/index')),
  //   exact: true,
  // },
  {
    path: '/participants/form/:slug',
    component: lazy(async () => await import('../pages/participants/participantForm')),
    exact: true,
  },
  {
    path: '/settings/organization-settings/task/participants-approval',
    component: lazy(async () => await import('../pages/participants/participantApproval')),
    exact: true,
  },
  {
    path: '/settings/organization-settings/task/plan-approval',
    component: lazy(
      async () => await import('../pages/settings/plan-management/planManagementApproval')
    ),
    exact: true,
  },
  {
    path: '/settings/organization-settings/task/pre-clearance-requests',
    component: lazy(async () => await import('../pages/settings/trade-pre-clearance/request')),
    exact: true,
  },
  {
    path: '/awards/rsu-awards',
    component: lazy(async () => await import('../pages/rsu-awards/index')),
    exact: true,
  },
  {
    path: '/awards/rsu-awards/:slug',
    component: lazy(async () => await import('../pages/rsu-awards/rsuAwardsForm')),
    exact: true,
  },
  {
    path: '/awards/psu-awards',
    component: lazy(async () => await import('../pages/psu-awards/index')),
    exact: true,
  },
  {
    path: '/awards/psu-awards/:slug',
    component: lazy(async () => await import('../pages/psu-awards/psuAwardsForm')),
    exact: true,
  },
  {
    path: '/awards/option-awards',
    component: lazy(async () => await import('../pages/option-awards/index')),
    exact: true,
  },
  {
    path: '/awards/option-awards/:slug',
    component: lazy(async () => await import('../pages/option-awards/optionsAwardsForm')),
    exact: true,
  },
  {
    path: '/awards/awards-agreement',
    component: lazy(async () => await import('../pages/award-agreement')),
    exact: true,
  },
  {
    path: '/awards/vesting-tranches',
    component: lazy(async () => await import('../pages/vesting-tranches')),
    exact: true,
  },
  {
    path: '/settings/organization-settings/task/rsu-awards-approval',
    component: lazy(async () => await import('../pages/rsu-awards/rsuAwardsApproval')),
    exact: true,
  },
  {
    path: '/settings/organization-settings/task/psu-awards-approval',
    component: lazy(async () => await import('../pages/psu-awards/psuAwardsApproval')),
    exact: true,
  },
  {
    path: '/settings/organization-settings/task/option-awards-approval',
    component: lazy(async () => await import('../pages/option-awards/optionsAwardsApproval')),
    exact: true,
  },
  {
    path: '/settings/organization-settings/task/participants-approval',
    component: lazy(async () => await import('../pages/participants/participantApproval')),
    exact: true,
  },
  {
    path: '/settings/organization-settings/task/settlement-config-approval',
    component: lazy(
      async () => await import('../pages/settings/settlement-config/settlementConfigApproval')
    ),
    exact: true,
  },
  {
    path: '/task/user-approval',
    component: lazy(async () => await import('../pages/settings/system-users/systemUserApproval')),
    exact: true,
  },
  {
    path: '/settings/organization-settings/task/user-approval',
    component: lazy(async () => await import('../pages/settings/system-users/systemUserApproval')),
    exact: true,
  },
  {
    path: '/settings/organization-settings/task/performance-rule-approval',
    component: lazy(
      async () => await import('../pages/settings/performance-rule/performanceRuleApproval')
    ),
    exact: true,
  },
  {
    path: '/task/rsu-vesting',
    component: lazy(async () => await import('../pages/overview/components/events/rsuEventPage')),
    exact: true,
  },
  {
    path: '/task/psu-vesting',
    component: lazy(async () => await import('../pages/overview/components/events/psuEventPage')),
    exact: true,
  },
  {
    path: '/task/option-vesting',
    component: lazy(
      async () => await import('../pages/overview/components/events/optionEventPage')
    ),
    exact: true,
  },
  // {
  //   path: '/task/federal-tax-approval',
  //   component: lazy(() => import('../pages/settings/Federal/FederalApprover')),
  //   exact: true,
  // },
  // {
  //   path: '/task/state-tax-approval',
  //   component: lazy(() => import('../pages/settings/tax/state/stateTaxApprover')),
  //   exact: true,
  // },
  // {
  //   path: '/task/local-tax-approval',
  //   component: lazy(() => import('../pages/settings/tax/local/localTaxApprover')),
  //   exact: true,
  // },
  {
    path: '/task-management-console',
    component: lazy(async () => await import('../pages/tmc')),
    exact: true,
  },
  {
    path: '/reports',
    component: lazy(async () => await import('../pages/reports/reports')),
    exact: true,
  },
  {
    path: '/reports/report-designer',
    component: lazy(async () => await import('../pages/reports/customize-report')),
    exact: true,
  },
  {
    path: '/reports/custom-report-designer',
    component: lazy(async () => await import('../pages/reports/customReportDesigner')),
    exact: true,
  },
  {
    path: '/reports/participant',
    component: lazy(async () => await import('../pages/reports/participant')),
    exact: true,
  },
  {
    path: '/reports/rsu-cancellation',
    component: lazy(async () => await import('../pages/reports/rsu-cancellation')),
    exact: true,
  },
  {
    path: '/reports/rsu-vesting',
    component: lazy(async () => await import('../pages/reports/rsu-vesting')),
    exact: true,
  },
  {
    path: '/reports/vesting',
    component: lazy(async () => await import('../pages/reports/vesting')),
    exact: true,
  },
  {
    path: '/reports/option',
    component: lazy(async () => await import('../pages/reports/option')),
    exact: true,
  },
  {
    path: '/reports/option-vesting',
    component: lazy(async () => await import('../pages/reports/option-vesting')),
    exact: true,
  },
  {
    path: '/reports/retirement-eligibility',
    component: lazy(async () => await import('../pages/reports/retirement-eligibility')),
    exact: true,
  },
  {
    path: '/reports/termination',
    component: lazy(async () => await import('../pages/reports/termination')),
    exact: true,
  },
  {
    path: '/transactions/purchase',
    component: lazy(async () => await import('../pages/transactions/purchase')),
    exact: true,
  },
  // {
  //   path: '/transactions/purchase/form/:slug',
  //   component: lazy(async () => await import('../pages/transactions/purchase/purchaseForm')),
  //   exact: true,
  // },
  {
    path: '/transactions/purchase/view',
    component: lazy(async () => await import('../pages/transactions/purchase/view')),
    exact: true,
  },
  {
    path: '/transactions/release',
    component: lazy(async () => await import('../pages/transactions/release')),
    exact: true,
  },
  {
    path: '/transactions/release/form/:slug',
    component: lazy(async () => await import('../pages/transactions/release/releaseForm')),
    exact: true,
  },
  {
    path: '/transactions/release/view',
    component: lazy(async () => await import('../pages/transactions/release/view')),
    exact: true,
  },
  {
    path: '/transactions/exercise',
    component: lazy(async () => await import('../pages/exercise')),
    exact: true,
  },
  {
    path: '/transactions/transfer-and-allocate',
    component: lazy(async () => await import('../pages/transactions/transfer-and-allocate')),
    exact: true,
  },
  {
    path: '/transactions/transfer-and-allocate/view',
    component: lazy(async () => await import('../pages/transactions/transfer-and-allocate/view')),
    exact: true,
  },
  {
    path: '/transactions/drs-registration',
    component: lazy(async () => await import('../pages/transactions/drs-registration')),
    exact: true,
  },
  {
    path: '/transactions/drs-registration/form/:slug',
    component: lazy(
      async () => await import('../pages/transactions/drs-registration/drsRegistrationForm')
    ),
    exact: true,
  },
  {
    path: '/transactions/drs-registration/view',
    component: lazy(async () => await import('../pages/transactions/transfer-and-allocate/view')),
    exact: true,
  },
  {
    path: '/transactions/external-transaction-import',
    component: lazy(async () => await import('../pages/transactions/externalTransactionImport')),
    exact: true,
  },
  {
    path: '/transactions/inbound-share-transfer-import',
    component: lazy(async () => await import('../pages/transactions/inboundShareTransferImport')),
    exact: true,
  },
  {
    path: '/transactions/unified-import-export',
    component: lazy(
      async () => await import('../pages/transactions/unified-transaction-import-export')
    ),
    exact: true,
  },
  {
    path: '/transactions/export',
    component: lazy(async () => await import('../pages/transactions/export')),
    exact: true,
  },
  {
    path: '/transactions/transfer-and-allocate/form/:slug',
    component: lazy(
      async () =>
        await import('../pages/transactions/transfer-and-allocate/transferAndAllocateForm')
    ),
    exact: true,
  },
  {
    path: '/transactions/external-tax-import',
    component: lazy(async () => await import('../pages/external-tax-transaction')),
    exact: true,
  },
  {
    path: '/profile',
    component: lazy(async () => await import('../pages/profile')),
    exact: true,
  },
  {
    path: '/security',
    component: lazy(async () => await import('../pages/settings/login-and-security')),
    exact: true,
  },
  {
    path: '/design',
    component: lazy(async () => await import('../pages/test')),
    exact: true,
  },
  // {
  //   path: '/udf',
  //   component: lazy(() => import('../pages/settings/UDF')),
  //   exact: true,
  // },
  {
    path: '/settings/organization-settings/task/tax-setup-approval',
    component: lazy(async () => await import('../pages/settings/tax/tax-setup/taxSetupApprover')),
    exact: true,
  },
  {
    path: '/task/tax-setup-approval/approver-history/:id',
    component: lazy(async () => await import('../pages/settings/tax/tax-setup/taxApproverHistory')),
    exact: true,
  },

  {
    path: '/notification',
    component: lazy(async () => await import('../pages/settings/notification')),
    exact: true,
  },

  {
    path: '/check-user',
    component: lazy(async () => await import('../pages/auth/checkUser')),
    exact: true,
  },
  {
    path: '/espp/create',
    component: lazy(async () => await import('../pages/espp/esppCreate')),
    exact: true,
  },
  {
    path: '/espp/edit',
    component: lazy(async () => await import('../pages/espp/esppEdit')),
    exact: true,
  },
  {
    path: '/espp',
    component: lazy(async () => await import('../pages/espp')),
  },
  {
    path: '/espp/participant',
    component: lazy(async () => await import('../pages/espp/esppParticipant')),
    exact: true,
  },
  {
    path: 'dashboard/brokerage-account/list',
    component: lazy(async () => await import('../pages/brokerage_account')),
    exact: true,
  },
  {
    path: 'dashboard/cash-transfer',
    component: lazy(async () => await import('../pages/cash-transfer/dashboard')),
    exact: true,
  },
  {
    path: 'dashboard/cash-transfer/list',
    component: lazy(async () => await import('../pages/cash-transfer')),
    exact: true,
  },
  {
    path: 'dashboard/brokerage-account',
    component: lazy(async () => await import('../pages/brokerage_account/dashboard')),
    exact: true,
  },
  {
    path: 'dashboard/brokerage-account/history',
    component: lazy(async () => await import('../pages/brokerage_account/history')),
    exact: true,
  },
  {
    path: 'dashboard/brokerage-account/government-documents',
    component: lazy(async () => await import('../pages/brokerage_account/government-documents')),
    exact: true,
  },
  {
    path: 'dashboard/trade-order/list',
    component: lazy(async () => await import('../pages/trade-order')),
    exact: true,
  },
  {
    path: 'dashboard/trade-order',
    component: lazy(async () => await import('../pages/trade-order/dashboard')),
  },
  {
    path: 'dashboard/transfer-and-allocate',
    component: lazy(async () => await import('../pages/transfer-and-allocate/dashboard')),
  },
  {
    path: 'dashboard/transfer-and-allocate/pending-shares',
    component: lazy(async () => await import('../pages/transfer-and-allocate/')),
  },
  {
    path: 'dashboard/transfer-and-allocate/details',
    component: lazy(async () => await import('../pages/transfer-and-allocate/details')),
  },
  {
    path: 'transfer-agent/drs-registration',
    component: lazy(async () => await import('../pages/drs-registration/dashboard')),
  },
  {
    path: 'transfer-agent/drs-registration/pending-shares',
    component: lazy(async () => await import('../pages/drs-registration/')),
  },
  {
    path: 'transfer-agent/drs-registration/details',
    component: lazy(async () => await import('../pages/drs-registration/details')),
  },
  {
    path: 'dashboard/bank-account',
    component: lazy(async () => await import('../pages/bank-account')),
  },
  {
    path: 'dashboard/disbursement',
    component: lazy(async () => await import('../pages/disbursement/dashboard')),
    exact: true,
  },
  {
    path: 'dashboard/disbursement/details',
    component: lazy(async () => await import('../pages/disbursement/detail')),
    exact: true,
  },
  {
    path: '/customer-list',
    component: lazy(async () => await import('../pages/vendor_customer/index')),
    exact: true,
  },
  {
    path: '/customer-list/create',
    component: lazy(async () => await import('../pages/vendor_customer/steps/index')),
    exact: true,
  },
  {
    path: '/customer-list/create/:id',
    component: lazy(async () => await import('../pages/vendor_customer/steps/index')),
    exact: true,
  },
  {
    path: '/customer-list/broker-sso-configuration',
    component: lazy(
      async () => await import('../pages/settings/brokerage-sso-configuration/brokerSsoConfigPage')
    ),
    exact: true,
  },
  {
    path: '/brokerage-import-export',
    component: lazy(async () => await import('../pages/transactions/export')),
    exact: true,
  },
  {
    path: '/transfer-agent',
    component: lazy(async () => await import('../pages/transfer-agent-import-export/index')),
    exact: true,
  },
  ...schemaRoutes,
  {
    path: '/logout',
    component: lazy(async () => await import('../pages/logout')),
    exact: true,
  },
  {
    path: '/logout/redirect',
    component: lazy(async () => await import('../pages/logout')),
    exact: true,
  },
  // @deprecated HTF-280: No longer navigated to programmatically. Replaced by ServerErrorModal.
  // Route kept as a safety net for direct URL access.
  {
    path: '/server-maintainance',
    component: lazy(async () => await import('../pages/serverMaintainance')),
    exact: true,
  },
  // Page Not Found
  {
    path: '/page-not-found',
    component: lazy(async () => await import('../pages/pageNotFound')),
    exact: true,
  },
  //cookie Clear page
  {
    path: '/redirect',
    component: lazy(async () => await import('../pages/cookieClearPage')),
    exact: true,
  },

  //Fair Value
  {
    path: '/awards/fair-value',
    component: lazy(async () => await import('../pages/fair-value/index')),
    exact: true,
  },
  {
    path: '/awards/unified-award-import',
    component: lazy(async () => await import('../pages/unified-award-import/index')),
    exact: true,
  },
  {
    path: '/awards/unified-awards',
    component: lazy(async () => await import('../pages/unified-awards/index')),
    exact: true,
  },
  {
    path: '/support',
    component: lazy(async () => await import('../pages/support/')),
  },
  // Accept Form
  {
    path: '/elect-form',
    component: lazy(async () => await import('../pages/elect-form')),
    exact: true,
  },
  //ISO view
  {
    path: '/iso-view',
    component: lazy(async () => await import('../pages/iso-view')),
    exact: true,
  },
  {
    path: '/email-template/edit',
    component: lazy(async () => await import('../pages/email-template/emailTemplateEdit')),
    exact: true,
  },
  // Job Scheduler
  {
    path: '/job-scheduler',
    component: lazy(async () => await import('../pages/job-scheduler')),
    exact: true,
  },
  {
    path: '/job-scheduler/logs',
    component: lazy(async () => await import('../pages/job-scheduler/logs')),
    exact: true,
  },
  // One Month Historical Stock Price
  // {
  //   path: '/one-month-historical-stock-price',
  //   component: lazy(async () => await import('../pages/historical-stock-price')),
  //   exact: true,
  // },
  // Historical Stock Price
  {
    path: '/historical-stock-price',
    component: lazy(
      async () => await import('../pages/overview/components/stock/overviewhistoricalStockPrice')
    ),
    exact: true,
  },
];
